import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from "angular-oauth2-oidc";
import { environment } from "../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private oAuthService: OAuthService) {
    this.setCustomFetch();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl = request.url.startsWith(environment.backendApi);
    if (isApiUrl && this.oAuthService.hasValidAccessToken()) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${this.oAuthService.getAccessToken()}` }
      });
      console.log('JwtInterceptor: Bearer token added to HttpClient request.');
    } else {
      console.log('JwtInterceptor: Bearer token not added to HttpClient request.');
    }

    return next.handle(request);
  }

  // this is function for adding bearer token also into fetch requests that are used for example for
  // leaflet that reading vector tiles for RedPoint map viewer in Dashboard
  private setCustomFetch() {
    const originalFetch = window.fetch;

    window.fetch = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
      const isApiUrl = typeof input === 'string' && input.startsWith(environment.backendApi);
      if (isApiUrl && this.oAuthService.hasValidAccessToken()) {
        const clonedInit: RequestInit = { ...init };
        const clonedHeaders = new Headers(clonedInit.headers || {});
        const token = `Bearer ${this.oAuthService.getAccessToken()}`;

        clonedHeaders.set("Authorization", token);
        clonedInit.headers = clonedHeaders;

        console.log('JwtInterceptor: Bearer token added to fetch request.');
        return originalFetch(input, clonedInit);
      } else {
        console.log('JwtInterceptor: Bearer token not added to fetch request.');
        return originalFetch(input, init);
      }
    };
  }
}
